<template lang="pug">
div#bin_card_item(@click="goToCard()", :class="domainClass()")
  .bin-related-card__title {{ title }}
</template>

<script>
import bin_card_mixin from 'common/mixins/bin_card_mixin'
import { computed } from 'vue'
import { mapState } from 'vuex'
import { trackEvent } from 'common/metrics'

export default {
  name: 'bin-card-related-item-vue',
  props: {
    title: { type: String, default: '' },
    domain: { type: String, default: '' },
    fullView: { type: Boolean, default: false }
  },
  computed: {
    queryParams() {
      const params = new URLSearchParams(window.location.search)
      return {
        tokenUrlId:  this.tokenId || params.get('token_id') ,
        searchUrlToken: this.searchTokens.length > 0 ? this.searchTokens : [params.get('search_token')]
      }
    },
    currentView() {
      return this.fullView ? 'full_view' : 'general_search'
    },
    ...mapState('search', ['tokenId', 'searchTokens']),
  },
  mixins: [bin_card_mixin.requests],
  methods: {
    domainClass() {
      return `bin-related-card__domain-${this.domain.toLowerCase()}`
    },
    goToCard() {
      const { tokenUrlId, searchUrlToken } = this.queryParams
      trackEvent(
        'BIN',
        'Click tarjeta relacionada',
        `${this.getCurrentView(this.fullView)}`
      )

      this.goToBINCard(this.title, tokenUrlId, searchUrlToken)
    },
  },
}
</script>
